const Footer = () => {
  return (
   <footer className="bg-gradient-to-b from-rose-200 via-pink-100 to-rose-300 text-gray-800 relative overflow-hidden">
  {/* Decorative Circles */}
  <div className="absolute -top-16 -left-16 w-72 h-72 bg-pink-300/20 rounded-full blur-3xl animate-slowFloat"></div>
  <div className="absolute -bottom-16 -right-16 w-80 h-80 bg-yellow-200/20 rounded-full blur-3xl animate-slowFloatReverse"></div>

  <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 relative z-10">
    {/* Logo & About */}
    <div className="space-y-4 flex flex-col items-start">
      <img
        src="/images/logos/iskcon-jaipur-black.png"
        alt="ISKCON Jaipur Logo"
        className="w-36"
      />
      <p className="text-gray-700 text-sm max-w-md">
        ISKCON Jaipur spreads Krishna consciousness through spiritual education, seva, and devotional activities.
      </p>
    </div>

    {/* Contact Info + Socials */}
    <div className="space-y-6">
      <h3 className="text-lg font-semibold mb-2 text-gray-800">Contact Us</h3>
      <ul className="space-y-2 text-gray-700 text-sm">
        <li>Email: <span className="hover:text-pink-400 transition">info@iskconjaipur.org</span></li>
        <li>Phone: <span className="hover:text-pink-400 transition">+91 7042668339</span></li>
        <li>Address: Sri Sri Giridhari Dauji Temple, Village Dholai, New Sanganer Road, opposite Vijay Path, Mansarovar, Jaipur, Rajasthan 302020</li>
      </ul>

      <div>
        <h3 className="text-lg font-semibold mb-2 text-gray-800">Follow Us</h3>
        {/* Social Icons */}
<div className="flex space-x-4 text-gray-700">
  {/* Instagram */}
  <a href="https://www.instagram.com/iskconjaipur.official" className="hover:text-pink-400 transition">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.97.24 2.427.403a4.92 4.92 0 011.675 1.085 4.92 4.92 0 011.085 1.675c.163.457.349 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.97-.403 2.427a4.92 4.92 0 01-1.085 1.675 4.92 4.92 0 01-1.675 1.085c-.457.163-1.257.349-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.97-.24-2.427-.403a4.92 4.92 0 01-1.675-1.085 4.92 4.92 0 01-1.085-1.675c-.163-.457-.349-1.257-.403-2.427C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.054-1.17.24-1.97.403-2.427a4.92 4.92 0 011.085-1.675 4.92 4.92 0 011.675-1.085c.457-.163 1.257-.349 2.427-.403C8.416 2.175 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.012 7.052.07 5.77.127 4.828.29 4.05.573a6.923 6.923 0 00-2.508 1.634A6.923 6.923 0 00.573 4.05C.29 4.828.127 5.77.07 7.052.012 8.332 0 8.741 0 12c0 3.259.012 3.668.07 4.948.057 1.282.22 2.224.503 3.002a6.923 6.923 0 001.634 2.508 6.923 6.923 0 002.508 1.634c.778.283 1.72.446 3.002.503C8.332 23.988 8.741 24 12 24s3.668-.012 4.948-.07c1.282-.057 2.224-.22 3.002-.503a6.923 6.923 0 002.508-1.634 6.923 6.923 0 001.634-2.508c.283-.778.446-1.72.503-3.002.058-1.28.07-1.689.07-4.948s-.012-3.668-.07-4.948c-.057-1.282-.22-2.224-.503-3.002a6.923 6.923 0 00-1.634-2.508 6.923 6.923 0 00-2.508-1.634c-.778-.283-1.72-.446-3.002-.503C15.668.012 15.259 0 12 0z" />
      <path d="M12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zm0 10.162a3.999 3.999 0 110-7.998 3.999 3.999 0 010 7.998zM18.406 4.594a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
    </svg>
  </a>

  {/* Facebook */}
  <a href="https://www.facebook.com/iskconjaipurofficial" className="hover:text-pink-400 transition">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24h11.495v-9.294H9.691V11.18h3.129V8.414c0-3.1 1.894-4.788 4.66-4.788 1.325 0 2.464.099 2.796.143v3.24h-1.918c-1.504 0-1.796.715-1.796 1.763v2.313h3.59l-.467 3.526h-3.123V24h6.116c.73 0 1.324-.593 1.324-1.324V1.325C24 .593 23.407 0 22.675 0z"/>
    </svg>
  </a>

  {/* YouTube */}
  <a href="https://www.youtube.com/@iskcon_Jaipur" className="hover:text-pink-400 transition">
    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="currentColor" viewBox="0 0 576 512">
      <path d="M549.655 124.083c-6.281-23.75-24.822-42.336-48.627-48.615C456.843 64 288 64 288 64s-168.843 0-212.999 11.468c-23.805 6.279-42.346 24.865-48.627 48.615C16 168.131 16 256 16 256s0 87.869 10.374 131.917c6.281 23.75 24.822 42.336 48.627 48.615C119.157 448 288 448 288 448s168.843 0 212.999-11.468c23.805-6.279 42.346-24.865 48.627-48.615C560 343.869 560 256 560 256s0-87.869-10.345-131.917zM232 336V176l142 80-142 80z"/>
    </svg>
  </a>
</div>

      </div>
    </div>
  </div>
</footer>


  );
};

export default Footer;

